import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import { ModalConfirm, ModalAlert } from "../su/Modals.js";


export default class PagePrivacyUpdate extends PageCommon {
    constructor() {
        super();
    }
    init($data) {
        super.init($data);
        this.showPreloader(false);
        Pqp.trace("PagePrivacyUpdate - Hello world");
        let mainWrapper = $(".main-wrapper");
        let privacyLink = $(".js-privacy", mainWrapper);
        if (privacyLink !== null && TheApp.Config !== null && TheApp.Config.Privacy) {
            privacyLink.attr("href", TheApp.Config.Privacy.Url);
        }

        PageCommon.disable($(".js-submit"), true);

        $(".js-step2-check0", mainWrapper).change(this.onCheckData.bind(this));

        let submit = document.querySelector(".js-submit");
        submit.addEventListener("click", this.onDoSubmit.bind(this));

        // dispaccio un evento globale
        try {
            this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
        } catch (error) {
            console.log(error);
        }
    }

    onCheckData = function () {
        let mainWrapper = $(".main-wrapper");
        let Privacy0 = $(".js-step2-check0", mainWrapper).prop("checked");

        let checkDataOk = true;
        if (!Privacy0) {
            checkDataOk = false;
        }
        PageCommon.disable($(".js-submit", mainWrapper), !checkDataOk);
        return checkDataOk;
    }


    onDoSubmit = function () {
        if (this.onCheckData()) {
            this.showPreloader(true);

            PageCommon.showPreloader(true);
            let mainWrapper = $(".main-wrapper");

            let rq = {
                PrivacyVersion: TheApp.Config.Privacy.Version,
                Privacy0: $(".js-step2-check0", mainWrapper).prop("checked") ? 1 : 0,
                Privacy1: $(".js-step2-check1", mainWrapper).prop("checked") ? 1 : 0,
                Privacy2: $(".js-step2-check2", mainWrapper).prop("checked") ? 1 : 0,
                Privacy3: 0,
            }
            thatServiceManeger.standardCall("/api/app/privacy-update", rq, this.onDoSubmitHandler.bind(this));
        }
    }

    onDoSubmitHandler(rs) {
        console.log("onDoSubmitHandler",rs);
        this.showPreloader(false);

        let showError = false;
        let errorMessage = "Impossibile aggiornare i consensi della privacy. Riprova tra qualche istante."
        let successMessage = "I consensi della privacy sono stati aggiornati correttamente.";
        if (rs.StatusCode !== 200) {
            showError = true;
        } else {
            showError = !rs.Success;
        }
        if (showError) {
            toastr.error(errorMessage);
            return;
        } else {
            toastr.success(successMessage);
            setTimeout(function () {
                window.location.href = '/';
            }, 1500);
            return;
        }
    }

    get isHomepage() {
        return true;
    }

}

